import * as ActionTypes from '../constants/actionTypes'
import { goodsList } from '../api/goods'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.GOODS_FETCHITEMS_LOAD })

  goodsList(params).then((res) => {
    const items = res.result

    const mockData = []
    items.map((item) => {
      mockData.push({
        key: item.idnum,
        title: item.s_name,
        type: item.s_type,
      })
    })

    dispatch({
      type: ActionTypes.GOODS_FETCHITEMS_SUCCEED,
      items: mockData,
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.GOODS_FETCHITEMS_FAIL,
      fetchGoodsError: 'Ошибка получения товаров',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/goods.js